/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DatasetDocument } from './DatasetDocument';
import { DatasetDocumentFromJSON, DatasetDocumentFromJSONTyped, DatasetDocumentToJSON } from './DatasetDocument';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface DatasetPolymorphicTextGenerationDataset
 */
export interface DatasetPolymorphicTextGenerationDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof DatasetPolymorphicTextGenerationDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof DatasetPolymorphicTextGenerationDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof DatasetPolymorphicTextGenerationDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPolymorphicTextGenerationDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {Array<DatasetDocument>}
   * @memberof DatasetPolymorphicTextGenerationDataset
   */
  readonly documents: Array<DatasetDocument>;
}

/**
 * Check if a given object implements the DatasetPolymorphicTextGenerationDataset interface.
 */
export function instanceOfDatasetPolymorphicTextGenerationDataset(
  value: object,
): value is DatasetPolymorphicTextGenerationDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('documents' in value) || value['documents'] === undefined) return false;
  return true;
}

export function DatasetPolymorphicTextGenerationDatasetFromJSON(json: any): DatasetPolymorphicTextGenerationDataset {
  return DatasetPolymorphicTextGenerationDatasetFromJSONTyped(json, false);
}

export function DatasetPolymorphicTextGenerationDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DatasetPolymorphicTextGenerationDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'],
    documents: (json['documents'] as Array<any>).map(DatasetDocumentFromJSON),
  };
}

export function DatasetPolymorphicTextGenerationDatasetToJSON(
  value?: Omit<DatasetPolymorphicTextGenerationDataset, 'id' | 'hasPredictions' | 'documents'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    dataset_path: value['datasetPath'],
  };
}
